import translation from './translation';

export default {
	translation,
};
